import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import ClassificacaoFiscalService from "service/fiscal/ClassificacaoFiscalService";
import { filterApplyTemplate, TextMatchModeOptions } from "utils/filterUtils";

const classificacaoFiscalService = new ClassificacaoFiscalService();

export default function ClassificacaoFiscalListagem() {
    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        descricao: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        ncm: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND }
    };

    return (
        <BaseListagem ordenacao="codigoInterno,ASC" service={classificacaoFiscalService} urlService="/classificacaoFiscal"
            tituloPagina="Classificações fiscais" defaultFilters={defaultFilters} showClearFilterButton nome="classificacaoFiscal">
            <Column field="codigoInterno" header="Código" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="ncm" header="NCM" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="ativa" header="Ativo" body={(rowData) => rowData.ativa ? "Sim" : "Não"} />
        </BaseListagem>
    );
}
